<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>紙本邀請函
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div>
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="PcDevice">
          <div class="contentBoxStatus py-3">
            <div class="d-flex align-items-center justify-content-around">
              <div
                v-for="(item, index) in MenuInvitation"
                :key="index"
                class="btn btn-white py-2 px-4"
                style="border-radius: 20px; border-color: #d9d9d9"
                @click="InviteLink(item.Url)"
              >
                <span
                  class="font-weight-bold text-primary"
                  style="font-size: 16px"
                  v-if="item.MenuName == '紙本邀請函'"
                >
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
                <span v-else>
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>
        <div class="contentBox">
          <!-- left -->
          <div class="proLeft NoShowInMobile align_c">
            <img src="@/assets/images/iconPaper.svg" width="100%" />
          </div>
          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <!-- <div class="MbDevice">
                        <h1> <img src="images/iconPaper.svg" width="35px" class="mb-2"> 紙本邀請函</h1>
                    </div> -->

            <div class="MbDevice">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="@/assets/images/iconPaper.svg"
                      width="35px"
                      class="mt-1 mr-1"
                    />
                  </div>
                  <div>
                    <h1>紙本邀請函</h1>
                  </div>
                </div>

                <!-- <div>
                  <h1><img src="@/assets/images/iconPaper.svg" width="35px" class="mb-2" /> 紙本邀請函</h1>
                </div> -->
                <div class="mb-2">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <span class="border py-1 px-3">
                        <i class="fas fa-ellipsis-h"></i>
                      </span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in MenuInvitation"
                        :key="index"
                      >
                        <span class="MbListGray" @click="InviteLink(item.Url)">
                          {{ item.MenuName }}
                        </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div class="PcDevice">
              <h1>紙本邀請函</h1>
            </div>
            <p class="my-3">&nbsp;</p>
            本展響應環保政策，逐漸減少紙張的使用，來賓邀請以電子邀請函為主。
            若有需求，您也可以申請紙本邀請函，郵寄或親自提供給您的客戶。收到的來賓須依照邀請函上說明，完成線上索票程序後，方可於展期憑完成索票後之「入場憑證
            QR Code」免費入場參觀一次。

            <p class="my-3">&nbsp;</p>

            <div v-if="!hasAccountId">
              <p class="my-3">&nbsp;</p>
              <div class="alert alert-danger" role="alert">
                <img src="@/assets/images/tickGray.svg" width="13px" alt="" />
                專屬邀請代碼異常，請洽大會業務人員。
              </div>
              <h3 class="mt-4 mb-3">大會業務聯絡窗口</h3>
              <div name="ExpoContact"></div>
            </div>

            <div v-else class="paper-lock-panel">
              <div class="paper-lock-content">
                <p class="lightLine">&nbsp;</p>
                <h3>需求調查</h3>
                <p class="my-3">&nbsp;</p>
                <ul>
                  <li>
                    請於
                    <span class="red"><span name="CloseDay"></span> 23:59</span>
                    前完成填寫，若逾時則視為無需求
                  </li>

                  <li>
                    此紙本邀請函不具直接入場資格，參觀者須完成線上索票流程方可免費入場乙次。
                  </li>
                </ul>
                <div class="grayBG mt-3" v-if="hasApply">
                  您是否需要申請：<span
                    style="text-decoration: underline"
                    v-if="InvQty == 1"
                    >需要</span
                  ><span style="text-decoration: underline" v-else>不需要</span>

                  <div class="mt-2">
                    填寫日期：<span style="text-decoration: underline">{{
                      UpdateTime
                    }}</span>
                  </div>
                </div>

                <p class="my-3">&nbsp;</p>
                <a
                  :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/invitePaperApply?no=${RegNo}`"
                  data-fancybox
                  data-type="iframe"
                  data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                  class="btnStyle iframeForm linkstyle"
                  v-if="!hasApply"
                  >立即填寫</a
                >

                <a
                  :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/invitePaperApply?no=${RegNo}`"
                  data-fancybox
                  data-type="iframe"
                  data-options='{"type" : "iframe", "iframe" : {"preload" : false, "css" : {"width" : "1000px"}}}'
                  class="btnStyle iframeForm linkstyle"
                  v-if="hasApply"
                  >修改</a
                >

                <div class="mt-5" v-if="InvitationSampleImg">
                  <p class="ml-2">※以下為紙本邀請函示意圖參考※</p>
                  <img
                    :src="`https://www.chanchao.com.tw/ExhibitionFiles/hardcopyInvitation/${InvitationSampleImg}`"
                    width="700px"
                    alt=""
                    class="img-fluid"
                  />
                </div>

                <p class="lightLine">&nbsp;</p>
                <h3>大會業務聯絡窗口</h3>
                <p class="my-3">&nbsp;</p>
                <div name="ExpoContact"></div>
              </div>
              <div class="paper-lock-message">
                本功能配合新年度展期時程開放，目前暫不提供服務，敬請見諒。
              </div>
            </div>
          </div>
          <p class="clear"></p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "紙本邀請函 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      InvQty: "",
      UpdateTime: "",
      InvCode: "",
      lang: "tw",
      InvitationSampleImg: "",
      hasAccountId: true,
      MenuInvitation: [],
      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      hasApply: false,
    };
  },
  methods: {
    InviteLink(Url) {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`;
      }
    },

    closefancybox() {
      parent.$.fancybox.close();
    },
  },

  created() {
    const vm = this;

    //取得語系

    let lang = "tw";

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    //取得參展商總資訊
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        vm.InvitationSampleImg = response.data.Data.InvitationSample;

        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });

    //判斷是否有AccountID
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data.Data)

        let AccountID = response.data.Data.AccountID;

        if (!AccountID) {
          vm.hasAccountId = false;

          $.getJSON(
            "/apiExhibitors/ExpoContact/" + RegNo + "?lang=" + lang,
            function (data) {
              $('[name="ExpoContact"]').html(data.Data.ExpoContact);
            },
          );
        } else {
          vm.hasAccountId = true;

          //取得既有資料

          let url = `/apiExhibitors/HardcopyInvitation/${vm.RegNo}?lang=${vm.lang}`;

          axios.get(url).then((response) => {
            if (response.data.Code == 200) {
              vm.InvQty = response.data.Data.InvQty;
              vm.InvCode = response.data.Data.InvCode;
              vm.hasApply = true;
              vm.UpdateTime = response.data.Data.UpdateTime;
            } else if (response.data.Code == 404) {
              vm.hasApply = false;
            }
          });
        }
      });

    //取得邀請選單
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.MenuInvitation = response.data.Data;
      });

    $.getJSON(
      "/apiExhibitors/Exhibition/" + vm.RegNo,
      { lang: lang },
      function (data) {
        //get close day
        //var CloseDay = new Date(data.ExhBegin)
        //CloseDay.setDate(CloseDay.getDate() - 70)
        //改抓API的deadline
        var CurrentDate = new Date();
        var ShowCloseDay = new Date(data.Data.HardcopyInvDeadLine);
        var SystemCloseDay = new Date(data.Data.HardcopyInvDeadLine);

        $('[name="CloseDay"]').text(formatDate(ShowCloseDay));
        function formatDate(date) {
          var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
          if (month.length < 2) month = "0" + month;
          if (day.length < 2) day = "0" + day;
          return [year, month, day].join("/");
        }

        SystemCloseDay.setDate(ShowCloseDay.getDate() + 1);

        if (CurrentDate > SystemCloseDay) {
          if (lang == "tw") {
            $(".btnStyle").addClass("btnExpire");
          } else {
            $(".btnStyle").addClass("ebtnExpire");
          }
        }

        //get contact info
        $.getJSON(
          "/apiExhibitors/ExpoContact/" + vm.RegNo + "?lang=" + lang,
          function (data) {
            $('[name="ExpoContact"]').html(data.Data.ExpoContact);
          },
        );
      },
    );
  },
};
</script>

<style lang="scss">
.linkstyle:hover {
  color: #ffffff;
}

.alert-danger {
  background-color: #f8d7da;
}

.alert {
  padding: 10px 10px;
  font-size: 15px;
}

.paper-lock-panel {
  position: relative;
  overflow: hidden;
  min-height: 420px;
  padding: 16px;
  border: 3px dashed #ffd87b;
}

.paper-lock-panel::before {
  content: "";
  position: absolute;
  z-index: 1;
  inset: 0;
  // background: rgba(255, 255, 255, 0.62);
  // backdrop-filter: blur(6px);
}

.paper-lock-content {
  filter: blur(3px);
  opacity: 0.42;
  pointer-events: none;
  user-select: none;
}

.paper-lock-message {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  width: calc(100% - 32px);
  transform: translate(-50%, -50%);
  color: #302a1b;
  font-size: 30px;
  font-weight: 550;
  line-height: 1.4;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .paper-lock-panel {
    min-height: 360px;
    padding: 12px;
  }

  .paper-lock-message {
    font-size: 24px;
  }
}
</style>
